import { Injectable, EventEmitter } from "@angular/core";
import { KreTableFieldConfig, KreFormFieldConfig } from "@kre-form/core";

@Injectable()
export class KreToFormFieldService {
  constructor() {}

  getKreFiledFunction(tableField: KreTableFieldConfig) {
    let field: KreFormFieldConfig = {};
    let fun: any;
    switch (tableField.dataType) {
      case "text":
        field = this.text(tableField);
        break;
      case "texti18n":
        field = this.textI18N(tableField);
        break;
      case "textarea":
        field = this.textArea(tableField);
        break;
      case "numbers":
        field = this.number(tableField);
        break;
      case "password":
        field = this.passWord(tableField);
        break;
      case "radio":
        field = this.radio(tableField);
        break;
      case "radiogroup":
        field = this.radioGroup(tableField);
        break;
      case "checkbox":
        field = this.checkbox(tableField);
        break;
      case "checkboxgroup":
        field = this.checkboxGroup(tableField);
        break;
      case "select":
        field = this.select(tableField);
        break;
      case "datetime":
        field = this.datetime(tableField);
        break;
      case "image":
        field = this.image(tableField);
        break;
      case "upload":
        field = this.upload(tableField);
        break;
      case "line":
        field = this.line(tableField);
        break;

      case "repeat":
        field = this.repeat(tableField);
        break;
      case "lookup":
        field = this.lookup(tableField);
        break;
      case "employee":
      case "position":
      case "organizational":
      case "area":
      case "legal":
      case "job":
      case "district":
        field = this.lookup2(tableField);
        field = this.lookup2(tableField);
        break;
      case "tree":
        field = this.tree(tableField);
        break;
      case "table":
        field = this.table(tableField);
        break;
      case "refer":
        field = this.refer(tableField);
        break;
      case "editor":
        field = this.editor(tableField);
      case "avatar":
        field = this.avatar(tableField);
        break;
      case "switch":
        field = this.switch(tableField);
        break;
      case "referProcess":
        field = this.referProcess(tableField);
        break;
    }

    return field;
  }

  //1、字符串
  text(field: KreTableFieldConfig) {
    let config: KreFormFieldConfig = {
      type: "text",
      key: field.fieldCode,
      defaultValue: field.defaultValue,
      templateOptions: {
        label: field.fieldName,
        required: field.allowNull == false ? true : false,
        maxLength: field.maxLength || 500,
        minLength: field.minLength || 0,
        placeholder: field.placeholder,
        isButintin: field.isButintin,
        tips: field.tips,
        pattern: field.pattern,
      },
      primitiveProperty: {
        maxLength: field.maxLength || 500,
        minLength: field.minLength || 0,
      },
      hide: false,
      show: true,

      status: 1,
      editor: true,
      tableCode: field.tableCode,
    };
    return config;
  }

  //2、多语言
  textI18N(field: KreTableFieldConfig) {
    let config: KreFormFieldConfig = {
      type: "texti18n",
      key: field.fieldCode,
      defaultValue: field.defaultValue,
      templateOptions: {
        label: field.fieldName,
        required: field.allowNull == false ? true : false,
        maxLength: field.maxLength || 500,
        minLength: field.minLength || 0,
        placeholder: field.placeholder,
        isButintin: field.isButintin,
        tips: field.tips,
        pattern: field.pattern,
      },
      primitiveProperty: {
        maxLength: field.maxLength || 500,
        minLength: field.minLength || 0,
      },
      status: 1,
      hide: false,
      show: true,

      editor: true,
      tableCode: field.tableCode,
    };
    return config;
  }

  //3、多行文本
  textArea(field: KreTableFieldConfig) {
    let config: KreFormFieldConfig = {
      type: "textarea",
      key: field.fieldCode,
      defaultValue: field.defaultValue,
      templateOptions: {
        label: field.fieldName,
        required: field.allowNull == false ? true : false,
        maxLength: field.maxLength,
        minLength: field.minLength || 0,
        placeholder: field.placeholder,
        isButintin: field.isButintin,
        tips: field.tips,
        pattern: field.pattern,
      },
      primitiveProperty: {
        maxLength: field.maxLength,
        minLength: field.minLength || 0,
      },
      status: 1,
      hide: false,
      show: true,

      editor: true,
      tableCode: field.tableCode,
    };
    return config;
  }

  //4、数字
  number(field: KreTableFieldConfig) {
    let config: KreFormFieldConfig = {
      type: "numbers",
      key: field.fieldCode,
      defaultValue: field.defaultValue,
      templateOptions: {
        label: field.fieldName,
        required: field.allowNull == false ? true : false,
        max: field.max,
        min: field.min,
        placeholder: field.placeholder,
        isButintin: field.isButintin,
        tips: field.tips,
        pattern: field.pattern,
        precision: field.accuracy,
      },
      primitiveProperty: {
        min: field.min || -999999,
        max: field.max || 999999,
        precision: field.accuracy,
      },
      status: 1,
      hide: false,
      show: true,

      editor: true,
      tableCode: field.tableCode,
    };
    return config;
  }

  //5、密码
  passWord(field: KreTableFieldConfig) {
    let config: KreFormFieldConfig = {
      type: "password",
      key: field.fieldCode,
      defaultValue: field.defaultValue,
      templateOptions: {
        label: field.fieldName,
        required: field.allowNull == false ? true : false,
        maxLength: field.maxLength,
        minLength: field.minLength,
        placeholder: field.placeholder,
        isButintin: field.isButintin,
        tips: field.tips,
        pattern: field.pattern,
      },
      primitiveProperty: {
        maxLength: field.maxLength,
        minLength: field.minLength || 0,
      },
      status: 1,
      hide: false,
      show: true,

      editor: true,
      tableCode: field.tableCode,
    };
    return config;
  }

  //6、单选
  radio(field: KreTableFieldConfig) {
    let config: KreFormFieldConfig = {
      type: "radio",
      key: field.fieldCode,
      defaultValue: field.defaultValue,
      templateOptions: {
        type: field.showType,
        label: field.fieldName,
        required: field.allowNull == false ? true : false,
        placeholder: field.placeholder,
        isButintin: field.isButintin,
        tips: field.tips,
        pattern: field.pattern,
      },
      status: 1,
      hide: false,
      show: true,

      editor: true,
      tableCode: field.tableCode,
    };
    return config;
  }

  //7、单选组
  radioGroup(field: KreTableFieldConfig) {
    let config: KreFormFieldConfig = {
      type: "radiogroup",
      key: field.fieldCode,
      defaultValue: field.defaultValue,
      templateOptions: {
        type: field.showType,
        label: field.fieldName,
        required: field.allowNull == false ? true : false,
        placeholder: field.placeholder,
        isButintin: field.isButintin,
        tips: field.tips,
        pattern: field.pattern,
      },
      status: 1,
      hide: false,
      show: true,

      editor: true,
      tableCode: field.tableCode,
    };
    return config;
  }

  //8、复选
  checkbox(field: KreTableFieldConfig) {
    let config: KreFormFieldConfig = {
      type: "checkbox",
      key: field.fieldCode,
      defaultValue: field.defaultValue,
      templateOptions: {
        type: field.showType,
        label: field.fieldName,
        required: field.allowNull == false ? true : false,
        placeholder: field.placeholder,
        isButintin: field.isButintin,
        tips: field.tips,
        pattern: field.pattern,
      },
      status: 1,
      hide: false,
      show: true,

      editor: true,
      tableCode: field.tableCode,
    };
    return config;
  }

  //9、复选组
  checkboxGroup(field: KreTableFieldConfig) {
    let config: KreFormFieldConfig = {
      type: "checkboxgroup",
      key: field.fieldCode,
      defaultValue: field.defaultValue,
      templateOptions: {
        type: field.showType,
        label: field.fieldName,
        required: field.allowNull == false ? true : false,
        placeholder: field.placeholder,
        isButintin: field.isButintin,
        tips: field.tips,
        pattern: field.pattern,
      },
      status: 1,
      hide: false,
      show: true,

      editor: true,
      tableCode: field.tableCode,
    };
    return config;
  }

  //10、下拉
  select(field: KreTableFieldConfig) {
    let config: KreFormFieldConfig = {
      type: "select",
      key: field.fieldCode,
      defaultValue: field.defaultValue,
      templateOptions: {
        type: field.showType,
        label: field.fieldName,
        required: field.allowNull == false ? true : false,
        selectType: field.selectType,
        parameterId: field.parameterId,
        options: field.parameterData,
        placeholder: field.placeholder,
        isButintin: field.isButintin,
        tips: field.tips,
        pattern: field.pattern,
      },
      status: 1,
      hide: false,
      show: true,

      editor: true,
      tableCode: field.tableCode,
    };
    return config;
  }

  //11、日期
  datetime(field: KreTableFieldConfig) {
    let config: KreFormFieldConfig = {
      type: "datetime",
      key: field.fieldCode,
      defaultValue: field.defaultValue,
      templateOptions: {
        type: field.secondType,
        label: field.fieldName,
        required: field.allowNull == false ? true : false,
        placeholder: field.placeholder,
        isButintin: field.isButintin,
        tips: field.tips,
        pattern: field.pattern,
        format: field.format,
      },
      primitiveProperty: {
        maxDate: field.maxDate || "2050-12-31",
        minDate: field.minDate || "1900-01-01",
      },
      status: 1,
      hide: false,
      show: true,

      editor: true,
      tableCode: field.tableCode,
    };
    return config;
  }

  //12、图片
  image(field: KreTableFieldConfig) {
    let config: KreFormFieldConfig = {
      type: "image",
      key: field.fieldCode,
      defaultValue: field.defaultValue,
      templateOptions: {
        label: field.fieldName,
        required: field.allowNull == false ? true : false,
        placeholder: field.placeholder,
        isButintin: field.isButintin,
        tips: field.tips,
        pattern: field.pattern,
      },
      status: 1,
      hide: false,
      show: true,

      editor: true,
      tableCode: field.tableCode,
    };
    return config;
  }

  //13、附件
  upload(field: KreTableFieldConfig) {
    let config: KreFormFieldConfig = {
      type: "upload",
      key: field.fieldCode,
      defaultValue: field.defaultValue,
      templateOptions: {
        label: field.fieldName,
        required: field.allowNull == false ? true : false,
        // attachment: {
        //   size: field.attachmentsize,
        //   type: field.attachmenttype,
        //   limit: field.attachmentlimit,
        // },
        placeholder: field.placeholder,
        isButintin: field.isButintin,
        tips: field.tips,
        pattern: field.pattern,
      },
      status: 1,
      hide: false,
      show: true,

      editor: true,
      tableCode: field.tableCode,
    };

    return config;
  }

  //14、line
  line(field: KreTableFieldConfig) {
    let config: KreFormFieldConfig = {
      type: "line",
      key: field.fieldCode,
      status: 1,
      hide: false,
      show: true,

      editor: true,
      tableCode: field.tableCode,
    };
    return config;
  }

  //15、repeat
  repeat(field: KreTableFieldConfig) {
    let type = "card";
    if (
      field.secondType &&
      field.secondType !== null &&
      field.secondType !== ""
    ) {
      type = field.secondType;
    }
    let config: KreFormFieldConfig = {
      type: "repeat",
      key: field.fieldCode,
      defaultValue: field.defaultValue,
      defaultText: field.defaultText,
      templateOptions: {
        type: type,
        label: field.fieldName,
        required: field.allowNull == false ? true : false,
        placeholder: field.placeholder,
        isButintin: field.isButintin,
        tips: field.tips,
        pattern: field.pattern,
        minLength: field.minLength,
        maxLength: field.maxLength,
      },
      primitiveProperty: {
        maxLength: field.maxLength,
        minLength: field.minLength || 0,
      },
      status: 1,
      hide: false,
      show: true,

      editor: true,
      tableCode: field.tableCode,
    };
    return config;
  }

  //16、弹框
  lookup(field: KreTableFieldConfig) {
    let config: KreFormFieldConfig = {
      type: "lookup",
      key: field.fieldCode,
      defaultValue: field.defaultValue,
      defaultText: field.defaultText,
      templateOptions: {
        type: field.showType,
        label: field.fieldName,
        required: field.allowNull == false ? true : false,
        placeholder: field.placeholder,
        isButintin: field.isButintin,
        tips: field.tips,
        pattern: field.pattern,
        selectType: field.selectType,
      },
      status: 1,
      hide: false,
      show: true,

      editor: true,
      tableCode: field.tableCode,
    };
    return config;
  }

  //17、人员employee | 职位position | 组织organizational | 地区area
  lookup2(field: KreTableFieldConfig) {
    let config: KreFormFieldConfig = {
      type: field.dataType,
      key: field.fieldCode,
      defaultValue: field.defaultValue,
      defaultText: field.defaultText,
      templateOptions: {
        type: field.showType,
        label: field.fieldName,
        required: field.allowNull == false ? true : false,
        placeholder: field.placeholder,
        isButintin: field.isButintin,
        tips: field.tips,
        pattern: field.pattern,
        minLength: field.minLength,
        maxLength: field.maxLength,
        selectType: field.selectType,
        parameterId: field.parameterId,
      },
      primitiveProperty: {
        maxLength: field.maxLength,
        minLength: field.minLength || 0,
      },
      status: 1,
      hide: false,
      show: true,

      editor: true,
      tableCode: field.tableCode,
    };
    return config;
  }

  //18、tree
  tree(field: KreTableFieldConfig) {
    let config: KreFormFieldConfig = {
      type: "tree",
      key: field.fieldCode,
      defaultValue: field.defaultValue,
      defaultText: field.defaultText,
      templateOptions: {
        type: field.showType,
        label: field.fieldName,
        required: field.allowNull == false ? true : false,
        placeholder: field.placeholder,
        isButintin: field.isButintin,
        tips: field.tips,
        pattern: field.pattern,
        minLength: field.minLength,
        maxLength: field.maxLength,
        selectType: field.selectType,
        parameterId: field.parameterId,
      },
      primitiveProperty: {
        maxLength: field.maxLength,
        minLength: field.minLength || 0,
      },
      status: 1,
      hide: false,
      show: true,

      editor: true,
      tableCode: field.tableCode,
    };
    return config;
  }
  //19、table
  table(field: KreTableFieldConfig) {
    let config: KreFormFieldConfig = {
      type: "table",
      key: field.fieldCode,
      defaultValue: field.defaultValue,
      defaultText: field.defaultText,
      templateOptions: {
        type: field.showType,
        label: field.fieldName,
        required: field.allowNull == false ? true : false,
        placeholder: field.placeholder,
        isButintin: field.isButintin,
        tips: field.tips,
        pattern: field.pattern,
        minLength: field.minLength,
        maxLength: field.maxLength,
        selectType: field.selectType,
        parameterId: field.parameterId,
      },
      primitiveProperty: {
        maxLength: field.maxLength,
        minLength: field.minLength || 0,
      },
      status: 1,
      hide: false,
      show: true,

      editor: true,
      tableCode: field.tableCode,
    };
    return config;
  }

  //20、job
  job(field: KreTableFieldConfig) {
    let config: KreFormFieldConfig = {
      type: "job",
      key: field.fieldCode,
      defaultValue: field.defaultValue,
      defaultText: field.defaultText,
      templateOptions: {
        label: field.fieldName,
        required: field.allowNull == false ? true : false,
        placeholder: field.placeholder,
        isButintin: field.isButintin,
        tips: field.tips,
        pattern: field.pattern,
        minLength: field.minLength,
        maxLength: field.maxLength,
        selectType: field.selectType,
        parameterId: field.parameterId,
      },
      primitiveProperty: {
        maxLength: field.maxLength,
        minLength: field.minLength || 0,
      },
      status: 1,
      hide: false,
      show: true,

      editor: true,
      tableCode: field.tableCode,
    };
    return config;
  }

  //21、refer
  refer(field: KreTableFieldConfig) {
    let config: KreFormFieldConfig = {
      type: "refer",
      key: field.fieldCode,
      defaultValue: field.defaultValue,
      defaultText: field.defaultText,
      templateOptions: {
        label: field.fieldName,
        required: field.allowNull == false ? true : false,
        placeholder: field.placeholder,
        isButintin: field.isButintin,
        tips: field.tips,
        pattern: field.pattern,
        minLength: field.minLength,
        maxLength: field.maxLength,
        selectType: field.selectType,
        parameterId: field.parameterId,
      },
      primitiveProperty: {
        maxLength: field.maxLength,
        minLength: field.minLength || 0,
      },
      status: 1,
      hide: false,
      show: true,

      editor: true,
      tableCode: field.tableCode,
    };
    return config;
  }

  //22、editor
  editor(field: KreTableFieldConfig) {
    let config: KreFormFieldConfig = {
      type: "editor",
      key: field.fieldCode,
      defaultValue: field.defaultValue,
      defaultText: field.defaultText,
      templateOptions: {
        type: field.showType,
        label: field.fieldName,
        required: field.allowNull == false ? true : false,
        placeholder: field.placeholder,
        isButintin: field.isButintin,
        tips: field.tips,
        pattern: field.pattern,
        minLength: field.minLength,
        maxLength: field.maxLength,
        selectType: field.selectType,
        parameterId: field.parameterId,
      },
      primitiveProperty: {
        maxLength: field.maxLength,
        minLength: field.minLength || 0,
      },
      status: 1,
      hide: false,
      show: true,

      editor: true,
      tableCode: field.tableCode,
    };
    return config;
  }

  //23
  avatar(field: KreTableFieldConfig) {
    let config: KreFormFieldConfig = {
      type: "avatar",
      key: field.fieldCode,
      defaultValue: field.defaultValue,
      templateOptions: {
        label: field.fieldName,
        required: field.allowNull == false ? true : false,
        placeholder: field.placeholder,
        isButintin: field.isButintin,
        tips: field.tips,
        pattern: field.pattern,
      },
      status: 1,
      hide: false,
      show: true,

      editor: true,
      tableCode: field.tableCode,
    };
    return config;
  }
  //24
  switch(field: KreTableFieldConfig) {
    let config: KreFormFieldConfig = {
      type: "switch",
      key: field.fieldCode,
      defaultValue: field.defaultValue,
      templateOptions: {
        label: field.fieldName,
        required: field.allowNull == false ? true : false,
        placeholder: field.placeholder,
        isButintin: field.isButintin,
        tips: field.tips,
        pattern: field.pattern,
      },
      status: 1,
      hide: false,
      show: true,

      editor: true,
      tableCode: field.tableCode,
    };
    return config;
  }

  //25
  referProcess(field: KreTableFieldConfig) {
    let config: KreFormFieldConfig = {
      type: "referProcess",
      key: field.fieldCode,
      defaultValue: field.defaultValue,
      templateOptions: {
        label: field.fieldName,
        required: field.allowNull == false ? true : false,
        placeholder: field.placeholder,
        isButintin: field.isButintin,
        tips: field.tips,
        pattern: field.pattern,
      },
      status: 1,
      hide: false,
      show: true,
      referProcessList: [],
      editor: true,
      tableCode: field.tableCode,
    };
    return config;
  }
}
